import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Constants } from '../../utils/constants';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-compound',
  templateUrl: './compound.component.html',
  styleUrls: ['./compound.component.css']
})
export class CompoundRenderer implements ICellRendererAngularComp {
  compound: string = '';
  alternativeCompoundName: string = '';
  isAlternativeNameValid: boolean = false;
  disabled: boolean = false;
  params: any;
  parent: any;
  useAlternativeName: boolean = false;
  maxlength: number = 14;
  label: string = 'Alternative name';
  alwaysVisible: boolean = false;

  constructor() { }

  refresh(): boolean {
    return false;
  }

  agInit(params: any): void {
    this.parent = params.context;
    this.params = params;
    this.compound = params.value;
    this.disabled = params.disabled;
    this.alwaysVisible = !!params.alwaysVisible;
    this.alternativeCompoundName = params.data.alternativeNameCompound;
    this.isAlternativeNameValid = !this.showAlternativeName() || (this.alternativeCompoundName != null && this.alternativeCompoundName.length > 0);
  }

  showAlternativeName(): boolean {
    this.useAlternativeName = Utils.showAlternativeName(this.compound, this.params.data.groundwater, this.params.data.surfacewater);
    return this.useAlternativeName;
  }

  hasSelectedModel(): boolean {
    const data = this.params?.data;
    if (!data) return false;
    return [data.surfacewater, data.groundwater, data.soil, data.dietary, data.nondietary, data.aquatic, data.terrestrial]
      .some((models: any[]) => Array.isArray(models) && models.length > 0);
  }

  omitIllegalCharactersInSubstanceNames(event: any) {
    Utils.omitIllegalCharacters(event,  Constants.illegalCharactersInSubstanceNames);
  }

  alternativeNameChanged(value: any) {
    this.params.data.alternativeNameCompound = value;
    this.isAlternativeNameValid = !this.showAlternativeName() || value.length > 0;
    this.validAlternativeName();
  }

  validAlternativeName() {
    this.parent.onValidateAlternativeNameCompound(this.isAlternativeNameValid);
  }
}
